
import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useFetchFamilyData } from './hooks/useFetchFamilyData';
import { useCreateFamily } from './hooks/useCreateFamily';
import { useFamilyMembers } from './hooks/useFamilyMembers';
import { FamilyMember } from './types';

export const useFamilySettings = (onError?: (error: string) => void) => {
  const { user } = useAuth();
  const [retryCount, setRetryCount] = useState(0);
  
  const {
    isLoading,
    family,
    members,
    error,
    fetchFamilyData
  } = useFetchFamilyData(user?.id, onError);
  
  const { isCreating, createFamily } = useCreateFamily(user?.id, fetchFamilyData);
  
  const {
    isInviting,
    isRemoving,
    inviteFamilyMember,
    removeFamilyMember
  } = useFamilyMembers(family, fetchFamilyData);
  
  const handleRetry = () => {
    setRetryCount(prev => prev + 1);
  };

  useEffect(() => {
    fetchFamilyData();
  }, [fetchFamilyData, retryCount]);

  return {
    isLoading: isLoading || isCreating || isInviting || isRemoving,
    family,
    members,
    error,
    createFamily,
    inviteFamilyMember,
    removeFamilyMember,
    handleRetry,
    fetchFamilyData
  };
};
